module.exports = __webpack_public_path__ + "static/quality_management-03a03b556208e9c9514a4ad698332e94.svg";